//
//
//
//

import carImg from '@/assets/img/map_car.png'
import qydImg from '@/assets/img/start.png'
import mddImg from '@/assets/img/end.png'
import pointImg from '@/assets/img/map_point.png'
import BMapGL from 'BMap'
import { formatDate } from '@utils'
// import BMap from 'BMap'

export default {
  name: 'TransMap',
  props: {
    width: {
      type: String,
      default: '90%'
    },
    height: {
      type: String,
      default: '100vh'
    },
    params: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  data() {
    return {
      map: null,
      startPoint: null, // 起点
      endPoint: null, // 终点
      gpsList: [],
      gpsInv: 30, // 点间隔时间，默认30分钟
      order: null
    }
  },
  created() {
  },
  mounted() {
    this.initMap()
  },
  methods: {
    initMap() {
      // GL版命名空间为BMapGL
      // 按住鼠标右键，修改倾斜角和角度
      var _this = this;
      _this.loadGps()
      this.map = new BMapGL.Map('allmap') // 创建Map实例
      this.map.enableScrollWheelZoom(true) // 开启鼠标滚轮缩放
      this.map.centerAndZoom(new BMapGL.Point(123.253118, 41.481175), 15)
      // if (this.params.TYPE == 1) {
      //     setTimeout(function() {
      //       _this.loadData().then(res => {
      //       _this.loadQydAndMdd()
      //     }).then(res => {
      //         setTimeout(function() {
      //           // _this.loadGps()
      //         },100);

      //       })
      //     },100);
       
      // } else {
      //     setTimeout(function() {
      //      _this.loadQydAndMdd().then(res => {
      //     setTimeout(function() {
      //       // _this.loadGps()
      //     },100);
      //   })
      //     },100);
        
      // }
    },
    loadData() {
      let _this = this
      _this.$vux.loading.show()
      let url = 'Trans_GPS.ashx?action=Form_Load'
      return this.$post(url, {
        ID: _this.params.TRANS_ID
      }, {
        login: false
      }).then(
        response => {
          _this.order = response
        }
      ).catch(
        response => {
          console.log(response, '请求失败')
        }
      )
    },
    // 提货的，只显示点
    renderLocation() {
      let _this = this
      let map = this.map

      let gpsList = this.gpsList
      var points = []
      if (gpsList.length > 0) {
        var gps = gpsList[gpsList.length - 1]
        var gps_time = new Date(gps.GPS_TIME.replace(/\-/g, '/')).getTime() / 1000
        let pt = new BMapGL.Point(gps.SLNG, gps.SLAT)
        pt.gps_data = gps
        points.push(pt)
      } else if (this.startPoint) {
        points.push(this.startPoint)
      }
      if (points.length > 0) {
        this.addMarket(points[0], new BMapGL.Icon(carImg, new BMapGL.Size(32, 32)))
      }
      this.setZoom(points)
    },
    // 显示轨迹
    renderMap() {
      let _this = this
      var pointIcon = new BMapGL.Icon(pointImg, new BMapGL.Size(16, 16))
      if (this.gpsList.length == 0) {
        let driving = new BMapGL.DrivingRoute(_this.map, {
          renderOptions: {
            map: _this.map,
            autoViewport: true,
            strokeColor: 'red',
            strokeWeight: 4,
            strokeOpacity: 0.2
          }
        })
        console.log(this.startPoint, this.endPoint)
        driving.search(this.startPoint, this.endPoint)
        this.setZoom([this.startPoint, this.endPoint])
        return
      }

      let map = this.map
      let points = []

      let gpsList = this.gpsList
      // let gps_count = gpsList.length

      // // 点间隔显示gps点
      // let addIndex = Math.floor(gps_count / 8)
      // for (let i = 0; i < gps_count; i++) {
      //   if (addIndex != 0 && (i + 2) % addIndex != 0 && i != 0 && i != gps_count - 1) {
      //     continue
      //   }
      //   var gps = gpsList[i]
      //   let pt = new BMapGL.Point(gps.SLNG, gps.SLAT)
      //   pt.gps_data = gps
      //   this.addMarket(pt, pointIcon)
      //   points.push(pt)
      // }
      // 改成比如有27个数据，去掉相同的（相邻的点经纬度一样取后面的）12个点，总共只有15个点，15 / 10 = 1.5 小于2，每个点都画
      //如果有21个点，21 /10 = 2.1, 每隔一个点画 GPS
      // let points = []; // 用于存储要在地图上显示的点的数组  
      let lastPoint = null; // 用于跟踪上一个点，以处理相邻相同点  
    
      // 过滤掉相邻且经纬度相同的点  
      let filteredList = [];  
      for (let i = 0; i < gpsList.length; i++) {  
          if (!lastPoint || (gpsList[i].SLNG !== lastPoint.SLNG && gpsList[i].SLAT !== lastPoint.SLAT)) {  
              filteredList.push(gpsList[i]);  
              lastPoint = gpsList[i];  
          }  
      }  
      // 计算剩余点的数量  
      let gps_count = filteredList.length;  
    
      // 根据剩余点的数量计算间隔  
      let addIndex = Math.round(gps_count / 20); // 假设我们希望大约每10个点显示一个  
      if (addIndex < 2) {  
          addIndex = 1; // 如果小于2，则每个点都显示  
      }  
    
      // 遍历过滤后的列表，根据间隔显示点  
      for (let i = 0; i < gps_count; i += addIndex) {  
          let gps = filteredList[i];  
          let pt = new BMapGL.Point(gps.SLNG, gps.SLAT);  
          pt.gps_data = gps;  
          this.addMarket(pt, pointIcon); // 假设addMarket是添加点到地图的方法  
          points.push(pt);  
      }  
      //  if (this.startPoint) points.unshift(this.startPoint)
      if (this.startPoint) points[0].gps_data = this.startPoint.gps_data
      /*
        // 时间间隔显示gps点
        var start_time = 0,
          inv_time = this.gpsInv * 60, // 两点之间间隔秒数
        for (let i = 0; i < gps_count; i++) {
          var gps = gpsList[i];
          var gps_time = new Date(gps.GPS_TIME.replace(/\-/g, "/")).getTime() / 1000;
          if (gps_time - start_time < inv_time && i != gps_count - 1) continue
          start_time = gps_time
          let pt = new BMapGL.Point(gps.SLNG, gps.SLAT);
          pt.gps_data = gps;
          this.addMarket(pt, pointIcon);
          points.push(pt);
        } */

      this.setZoom([].concat(points, [this.endPoint]))
      if (points.length > 0) {
        this.addMarket(points[0], new BMapGL.Icon(qydImg, new BMapGL.Size(32, 32)))
      }
      if (points.length > 1) {
        this.addMarket(points[points.length - 1], new BMapGL.Icon(carImg, new BMapGL.Size(32, 32)))
        let pl = new BMapGL.Polyline(points, {
          strokeColor: 'blue',
          strokeWeight: 4,
          strokeOpacity: 0.8
        })
        map.addOverlay(pl)
      }
      if (this.endPoint) this.addMarket(this.endPoint, new BMapGL.Icon(mddImg, new BMapGL.Size(32, 32)))
    },
    addMarket(point, icon) {
      let marker
      if (icon) {
        marker = new BMapGL.Marker(point, {
          icon: icon
        }) // 创建标注
      } else {
        marker = new BMapGL.Marker(point) // 创建标注
      }
      this.map.addOverlay(marker) // 将标注添加到地图中
      marker.addEventListener('click', function () {
        let infoWindow = new BMapGL.InfoWindow(formatDate(point.gps_data.GPS_TIME, 'MM-dd HH:mm') + '<br/>' +
          point.gps_data.ADDR, {
          title: ''
        }) // 创建信息窗口对象
        this.openInfoWindow(infoWindow)
      })
    },
    setZoom(points) {
      if (points.length > 0) {
        var maxLng = points[0].lng
        var minLng = points[0].lng
        var maxLat = points[0].lat
        var minLat = points[0].lat
        var res
        for (var i = points.length - 1; i >= 0; i--) {
          res = points[i]
          if (res.lng > maxLng) maxLng = res.lng
          if (res.lng < minLng) minLng = res.lng
          if (res.lat > maxLat) maxLat = res.lat
          if (res.lat < minLat) minLat = res.lat
        }
        var cenLng = (parseFloat(maxLng) + parseFloat(minLng)) / 2
        var cenLat = (parseFloat(maxLat) + parseFloat(minLat)) / 2
        var zoom = this.getZoom(maxLng, minLng, maxLat, minLat)
        // var zoom = 50
        if (zoom > 12) zoom = 12
        this.map.centerAndZoom(new BMapGL.Point(cenLng, cenLat), zoom)
      } else {
        // 没有坐标，显示全中国
        this.map.centerAndZoom(new BMapGL.Point(103.388611, 35.563611), 5)
      }
    },
    // 根据经纬极值计算绽放级别。
    getZoom(maxLng, minLng, maxLat, minLat) {
      var zoom = ['50', '100', '200', '500', '1000', '2000', '5000', '10000', '20000', '25000', '50000', '100000',
        '200000', '500000', '1000000', '2000000'
      ] // 级别18到3。
      var pointA = new BMapGL.Point(maxLng, maxLat) // 创建点坐标A
      var pointB = new BMapGL.Point(minLng, minLat) // 创建点坐标B
      var distance = this.map.getDistance(pointA, pointB).toFixed(1) // 获取两点距离,保留小数点后两位
      for (var i = 0, zoomLen = zoom.length; i < zoomLen; i++) {
        if (zoom[i] - distance > 0) {
          return 18 - i + 2 // 之所以会多3，是因为地图范围常常是比例尺距离的10倍以上。所以级别会增加3。
        }
      }
    },
    loadGps() {
      let _this = this
      let url = 'Trans_GPS.ashx?action=Form_Query'
      this.params.ORDER_FIELD = 'GPS_TIME'
      this.params.ORDER_BY = 'asc'
      this.$post(url, this.params, {
        login: false
      }).then(
        response => {
          _this.gpsList = response.filter(e => e.SLAT && e.SLNG)
          if (this.params.TYPE == 1) {
            _this.loadData().then(res => {
                _this.loadQydAndMdd()
              }).then(res => {
                setTimeout(function () {
                  // _this.loadGps()
                }, 100);

              })
          } else {
            setTimeout(function () {
                  // _this.loadGps()
            }, 100);

          }
          // if (_this.params.TYPE === 0) {
          //   // _this.renderLocation()
          // } else {
          //   // _this.renderMap()
          // }
        }
      ).catch(
        response => {
          console.log(response, '请求失败')
        }
      )
    },
    loadQydAndMdd() {
      let _this = this
      let url = 'Agent_Doc.ashx?action=Agent_GPS'
      return this.$post(url, {
        CODE_102: this.params.CODE_102, // 送货仓库
        CODE_103: this.params.CODE_103 // 提货仓库
      }, {
        login: false
      }).then(
        response => {
          response.forEach(function (item) {
            item.ADDR = item.AGENT_FNAME
            if (item.AGENT_CODE == _this.params.CODE_103) {
              // item.LONGITUDE = _this.gpsList[0].BLNG; item.LATITUDE = _this.gpsList[0].BLAT
              var pt = new BMapGL.Point(item.LONGITUDE, item.LATITUDE);
              pt.gps_data = item
              _this.startPoint = pt
              if (_this.order) pt.gps_data.GPS_TIME = _this.order.DT_TH
              debugger
            } else if (item.AGENT_CODE == _this.params.CODE_102) {
              // item.LONGITUDE = _this.gpsList[_this.gpsList.length - 1].BLNG; item.LATITUDE = _this.gpsList[_this.gpsList.length - 1].BLAT
              var pt = new BMapGL.Point(item.LONGITUDE, item.LATITUDE);
              pt.gps_data = item
              _this.endPoint = pt
              if (_this.order) pt.gps_data.GPS_TIME = _this.order.DT_SIGN || _this.order.DTR_OVER
            }
            _this.renderMap()
          })
        }
      ).catch(
        response => {
          console.log(response, '请求失败')
        }
      )
    }
  }

}



// WEBPACK FOOTER //
// ./src/components/TransMapSctsnew.vue